import { CommonEnums } from '../../common.enums';

export class Input_Attr_Lnk {
    input_Inst_Id: number;
    input_Inst_Attr_Id: number;
    input_Inst_Obj_Id: number;
    dxMp_Id: number;
    lnk_Obj_Id: number;
    lnk_Obj_Attr_Id: number;
    valid_Cd: string;

    input_Inst_AttrNm: string;
    input_Inst_DTypNm: String;
    srcColNm: string;
    srcDTypNm: string;

    constructor() {
        this.setDefaults()
    }

    getPrimaryKey(): string {
        return this.input_Inst_Id + '.' + this.input_Inst_Attr_Id + '.' + this.input_Inst_Obj_Id +
            '.' + this.dxMp_Id;
    }

    setDefaults(): void {
        this.input_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.input_Inst_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.input_Inst_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Obj_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.resetReadOnlyProperties();
    }

    resetReadOnlyProperties(): void {
        this.input_Inst_AttrNm = CommonEnums.defaults.STRING_EMPTY;
        this.input_Inst_DTypNm = CommonEnums.defaults.STRING_EMPTY;
        this.srcColNm = CommonEnums.defaults.STRING_EMPTY;
        this.srcDTypNm = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(input_Attr_LnkTmp: Input_Attr_Lnk): Input_Attr_Lnk {
        let input_Attr_Lnk: Input_Attr_Lnk = new Input_Attr_Lnk();
        input_Attr_Lnk.copyFrom(input_Attr_LnkTmp);
        return input_Attr_Lnk;
    }

    copy(): Input_Attr_Lnk {
        let input_Attr_LnkTmp: Input_Attr_Lnk = new Input_Attr_Lnk();

        input_Attr_LnkTmp.input_Inst_Id = this.input_Inst_Id;
        input_Attr_LnkTmp.input_Inst_Attr_Id = this.input_Inst_Attr_Id;
        input_Attr_LnkTmp.input_Inst_Obj_Id = this.input_Inst_Obj_Id;
        input_Attr_LnkTmp.dxMp_Id = this.dxMp_Id;
        input_Attr_LnkTmp.lnk_Obj_Id = this.lnk_Obj_Id;
        input_Attr_LnkTmp.lnk_Obj_Attr_Id = this.lnk_Obj_Attr_Id;
        input_Attr_LnkTmp.valid_Cd = this.valid_Cd;
        input_Attr_LnkTmp.input_Inst_AttrNm = this.input_Inst_AttrNm;
        input_Attr_LnkTmp.input_Inst_DTypNm = this.input_Inst_DTypNm;
        input_Attr_LnkTmp.srcColNm = this.srcColNm;
        input_Attr_LnkTmp.srcDTypNm = this.srcDTypNm;

        return input_Attr_LnkTmp;
    }

    copyFrom(input_Attr_LnkTmp: Input_Attr_Lnk): void {
        this.input_Inst_Id = input_Attr_LnkTmp.input_Inst_Id;
        this.input_Inst_Attr_Id = input_Attr_LnkTmp.input_Inst_Attr_Id;
        this.input_Inst_Obj_Id = input_Attr_LnkTmp.input_Inst_Obj_Id;
        this.dxMp_Id = input_Attr_LnkTmp.dxMp_Id;
        this.lnk_Obj_Id = input_Attr_LnkTmp.lnk_Obj_Id;
        this.lnk_Obj_Attr_Id = input_Attr_LnkTmp.lnk_Obj_Attr_Id;
        this.valid_Cd = input_Attr_LnkTmp.valid_Cd;
        this.input_Inst_AttrNm = input_Attr_LnkTmp.input_Inst_AttrNm;
        this.input_Inst_DTypNm = input_Attr_LnkTmp.input_Inst_DTypNm;
        this.srcColNm = input_Attr_LnkTmp.srcColNm;
        this.srcDTypNm = input_Attr_LnkTmp.srcDTypNm;
    }

    compare(input_Attr_LnkTmp: Input_Attr_Lnk): string {
        let input_Attr_LnkString: string = this.toString(false);
        let input_Attr_LnkTmpString: string = input_Attr_LnkTmp.toString(false);

        if (input_Attr_LnkString != input_Attr_LnkTmpString) {
            return input_Attr_LnkString + ', ' + input_Attr_LnkTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Input_Attr_Lnk [input_Inst_Id=" + this.input_Inst_Id + ", input_Inst_Attr_Id=" + this.input_Inst_Attr_Id +
            ", input_Inst_Obj_Id=" + this.input_Inst_Obj_Id + ", dxMp_Id=" + this.dxMp_Id + ", lnk_Obj_Id=" + this.lnk_Obj_Id +
            ", lnk_Obj_Attr_Id=" + this.lnk_Obj_Attr_Id + ", valid_Cd=" + this.valid_Cd;

        if (isNotCompare) {
            str += ", input_Inst_AttrNm=" + this.input_Inst_AttrNm +
                ", input_Inst_DTypNm=" + this.input_Inst_DTypNm +
                ", srcColNm=" + this.srcColNm +
                ", srcDTypNm=" + this.srcDTypNm;
        }

        str += ']';
        return str;
    }
}